import * as React from "react";
import { forwardRef } from "react";
const SvgJobsIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 18, viewBox: "0 0 14 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.83317 1.5V7.33333H12.8332L6.1665 16.5V10.6667H1.1665L7.83317 1.5Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgJobsIcon);
export default ForwardRef;
